<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content class="caaks-dialog-text">{{ data.message }}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="primary" [mat-dialog-close]="true">{{ data.confirmLabel }}</button>
</mat-dialog-actions>